module.exports = __webpack_public_path__ + "static/media/rings.5fdddb29.jpg";